module.exports = __webpack_public_path__ + "img/Delete.13ff643d.svg";